<div class="legal-container">
  <div class="header-left">
    <button type="button" class="back-btn" (click)="goBack()">
      <i class="fas fa-arrow-left"></i>
      <span>Retour à l'accueil</span>
    </button>
  </div>
  <header class="legal-header">
    <div class="logo-container">
      <img src="assets/images/logo-2.png" alt="YokaStar Logo">
    </div>
    <h1>Normes de Protection des Enfants - YokaStar</h1>
    <p class="subtitle">Normes contre l'exploitation et les abus sexuels sur mineurs (CSAE)</p>
    <p class="subtitle">Dernière mise à jour : {{ currentDate | date: 'longDate' }}</p>
  </header>

  <main class="legal-content">
    <section class="intro-section">
      <p>
        <strong>YokaStar</strong> prend très au sérieux la sécurité des enfants sur sa plateforme et s'engage à lutter
        contre l'exploitation sexuelle et les abus sur mineurs (CSAE). Cette page présente nos normes et politiques
        publiées en matière de protection des enfants, conformément aux exigences de Google Play pour les applications
        des catégories Social et Dating.
      </p>
    </section>

    <section class="definitions-section">
      <h2><i class="fas fa-book icon"></i> Définitions</h2>
      <div class="grid-layout">
        <div class="definition-card">
          <h3>CSAE - Exploitation et abus sexuels sur mineurs</h3>
          <p>
            CSAE désigne l'exploitation sexuelle et les abus sur mineurs, incluant tout contenu ou comportement qui
            exploite sexuellement, abuse ou met en danger des enfants. Cela comprend notamment :
          </p>
          <ul>
            <li>Le grooming (préparation d'un enfant à une exploitation sexuelle)</li>
            <li>La sextorsion d'enfants</li>
            <li>Le trafic d'enfants à des fins sexuelles</li>
            <li>Toute autre forme d'exploitation sexuelle d'enfants</li>
          </ul>
        </div>
        <div class="definition-card">
          <h3>CSAM - Matériel d'abus sexuel sur mineurs</h3>
          <p>
            CSAM désigne le matériel d'abus sexuel sur mineurs. Ce contenu est illégal et strictement interdit sur
            YokaStar. Il s'agit de toute représentation visuelle (photos, vidéos, imagerie générée par ordinateur)
            impliquant un mineur dans une conduite sexuellement explicite.
          </p>
        </div>
      </div>
    </section>

    <section class="commitments-section">
      <h2><i class="fas fa-shield-alt icon"></i> Nos engagements</h2>
      <div class="grid-layout">
        <div class="commitment-item">
          <i class="fas fa-ban"></i>
          <h3>Zéro tolérance</h3>
          <p>YokaStar applique une politique de zéro tolérance envers tout contenu ou comportement lié au CSAE ou au CSAM. Tout contenu de ce type sera immédiatement supprimé et les comptes concernés seront suspendus.</p>
        </div>
        <div class="commitment-item">
          <i class="fas fa-balance-scale"></i>
          <h3>Conformité légale</h3>
          <p>Nous nous conformons à toutes les lois applicables en matière de protection des enfants et de lutte contre l'exploitation sexuelle, dans toutes les juridictions où nous opérons.</p>
        </div>
        <div class="commitment-item">
          <i class="fas fa-exclamation-triangle"></i>
          <h3>Action appropriée</h3>
          <p>Lorsque nous avons connaissance de contenu CSAM sur notre plateforme, nous prenons les mesures appropriées conformément à nos normes publiées et aux lois en vigueur, notamment la suppression immédiate du contenu.</p>
        </div>
      </div>
    </section>

    <section class="reporting-section">
      <h2><i class="fas fa-flag icon"></i> Signalement</h2>
      <p>
        YokaStar met à disposition des utilisateurs un mécanisme de signalement accessible directement dans l'application.
        Les utilisateurs peuvent signaler tout contenu ou comportement suspect sans quitter l'application.
      </p>
      <p>
        Si vous constatez un contenu ou un comportement qui pourrait constituer du CSAE ou du CSAM, veuillez le signaler
        immédiatement via notre fonction de signalement in-app ou en contactant notre point de contact dédié ci-dessous.
      </p>
    </section>

    <section class="contact-section">
      <h2><i class="fas fa-envelope icon"></i> Point de contact - Sécurité des enfants</h2>
      <p>
        Pour toute question concernant nos pratiques de prévention du CSAM, nos normes de protection des enfants,
        ou pour signaler un cas d'urgence, veuillez contacter notre point de contact dédié :
      </p>
      <div class="contact-card">
        <p><strong>Email : </strong> <a href="mailto:childsafety&#64;yokastar.com">childsafety&#64;yokastar.com</a></p>
        <p><strong>Adresse :</strong> 11 Bis, Av. Okapi; Q/Congo C/Ngaliema Kinshasa/ R.D.Congo</p>
      </div>
    </section>
  </main>

  <app-legal-footer></app-legal-footer>
</div>
